import ViewOrganization from './ViewOrganization'

export default ViewOrganization
